import styled from "styled-components";

export const Container = styled.main`
    width: 90%;
    width: -webkit-calc(100% - 67px);
    width: -moz-calc(100% - 67px);
    width: calc(100% - 67px);
    display: flex;
    flex-direction: column;
    grid-template-columns: 100%;
    float: right;
    padding: 20px;
    height: calc(100% - 69px);  
    z-index : 1 ;

    @media(max-width: 493px) {
        width: -webkit-calc(100% -46px);
        width: -moz-calc(100% - 46px);
        width: calc(100% - 46px);
        height: calc(100% - 55px);  
        padding: 12px 10px;
    }
    @media(max-width: 280px) {
        width: -webkit-calc(100% -33px);
        width: -moz-calc(100% - 33px);
        width: calc(100% - 33px);  
        padding: 12px 6px;     
    }

    .btnsregra{
        margin-top: 5px;

        button{
            background: var(--verde);
            color: #fff;
            padding: 5px 13px;
            font-size: 0.7rem;
            font-weight: 100;

            &:hover{
                background: var(--darkblue);
            }
        }
    }
`

export const Gridtit = styled.div`
    display: flex;
`

export const Titulo = styled.h1`
    font-size: 1.3rem;
    padding-right: 20px;
    margin-bottom: 5px;
    margin-right: 20px;
    color: var(--darkblue);
    margin-top: 15px;
    line-height: 1.3rem;

    span{
        color: var(--pink);
    }
    small{
        font-size: 1.1rem;       
        
    }
    @media(max-width: 860px) {
        margin-top: 0px;
    }
    @media(max-width: 550px) {
      font-size: 1rem;
      line-height: 1.1rem;
    }
    @media(max-width: 280px) {
      font-size: 0.85rem;
      line-height: 0.95rem;
    }
`

export const Biggrid = styled.div`
    margin: 25px 0;
    display: block; 
    @media(max-width: 450px){
        left: -56px;
        width: calc(100% + 56px);
    }   
    @media(max-width: 280px){
        margin: 10px 0;
        left: -39px;
        width: calc(100% + 45px);
    } 
`
export const CicloAtual = styled.div<{dispCiclo?: boolean}>`
    width: calc(25% - 20px);
    display: ${props => props.dispCiclo ? 'block' : 'none' };
    padding-bottom: 5px;
    float: left;
    height: 100%;
    
    &>div{
        background: #fff;

        table{
            tr{ border-bottom: 1px #EDEDED solid;}
        }
    }

    @media(max-width: 1720px) {
        width: calc(33.33% - 20px);
    }
    @media(max-width: 1300px) {
        width: calc(50% - 20px);
    }
    @media(max-width: 860px) {
        width: calc(100% - 40px);
    }
    @media(max-width: 450px) {
        width: calc(100% - 46px);
    }
    @media(max-width: 280px) {
        width: calc(100% - 39px);
    }

`
export const CiclosAntigos = styled.div<{dispCiclo?: boolean}>`
    width: calc(75% - 20px);
    display: ${props => props.dispCiclo ? 'flex' : 'none' };
    overflow: hidden;
    padding-bottom: 5px;
    float: left;
    height: 100%;
    scroll-behavior: smooth;
    
    &>div{
        background: #e7e3d9;
        width: calc(33.3333% - 20px);
        min-width: calc(33.3333% - 20px);
        flex-basis: auto;
        flex-grow: 1;
        
        table{
            tr{ border-bottom: 1px #d7d3ca solid;}
        }
        
    }

    @media(max-width: 1720px) {
        width: calc(66.6666% - 20px);

        &>div{
            width: calc(50% - 20px);
            min-width: calc(50% - 20px);
        }
    }
    @media(max-width: 1300px) {
        width: calc(50% - 20px);

        &>div{
            width: calc(100% - 20px);
            min-width: calc(100% - 20px);
        }
    }

    @media(max-width: 860px) {
        width: calc(100% - 40px);
        &>div{
            width: calc(100% - 10px);
            min-width: calc(100% - 10px);
        }
    }
    @media(max-width: 450px) {
        width: calc(100% - 46px);
    }
    @media(max-width: 280px) {
        width: calc(100% - 39px);
    }
`

export const IniText = styled.div`
  overflow: auto;
  max-height: 135px;
  ::-webkit-scrollbar{
    width: 8px;
    background: rgba(0,0,0,0.1);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb{
    background: #fff;
    border-radius: 10px;
    border: 2px solid #d6d2c9;
  }
  @media(max-width: 280px) {
    max-height: 117px;
  }
`

export const Thumb = styled.div`
    width: 6.5rem;
    display: block;
    height: 6.5rem;
    float: left;
    margin-right: 1rem;
    overflow: hidden;    
    min-width: 6.5rem;
    box-shadow: 1px 1px 3px rgb(0,0,0,0.2);
    border-radius: 50%;

    img{
        width: 100%;
        height: 100%;
    }

    .nothumb{
        background: var(--verde);
        width: 100%;
        height: 100%;
        border-radius: 50%;
        text-align: center;
        align-items: center;
        display: flex;
        justify-content: center;
        border: solid 8px rgba(255,255,255,0.1);
        font-size: 2.3rem;
        font-weight: 900;
        text-shadow: 0px 3px 0 rgb(255,255,255,0.2);
        margin-right: 10px;
        color: #fff;
        text-transform: uppercase;
        
    }

    @media(max-width: 860px) {
        width: 3rem;
        height: 3rem;
        min-width: 3rem;
    }
    @media(max-width: 280px) {
        margin-right: 5px;

        .nothumb{
          border: solid 2px rgba(255,255,255,0.1);
          font-size: 2rem;
        }
    }
`

export const PositButtons = styled.div`
    position: fixed;
    left: 11px;
    top: 70px;  
    z-index: 2;
    
    .newciclo{ 
        position: absolute;
        top: 120px;
        left: 0px;
        background: none;
        width: 100%;

        span{
            transition: 0.9s;
            color: var(--verde);
            font-size: 2rem;
        }
        span:hover{
            color: #fff
        }
    }

    @media(max-width: 493px) {
        top: 52px;
        left: 0px;
        margin: 0 6px;
        .newciclo{ 
            top: 100px;
        }
    }
    @media(max-width: 450px) {
        height: 150px;
        background: var(--darkblue);
        .newciclo{
            background: var(--darkblue);
        }
    }

    @media(max-width: 280px) {
        height: 89px;
        
        .newciclo{
          width: calc(100% + 9px);
          left: -4px;
          top: 89px
        }
    }

`

export const Nociclos = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    align-content: center;
    font-size: 0.66rem;
    flex-direction: column;
    color: var(--pink);

    button{
        padding-left: 20px;
        padding-right: 20px;
        font-size: 0.9rem;
    }
`